enum TabMode {
    ORDERS = 0,
    SETTINGS = 1,
}

export default TabMode;